import {GoogleMapMainAreaKey, GoogleMapSubAreaApiKeys} from "../../consts.js";

export const getMainAreaLayer = addressComponents =>
    addressComponents?.find(({types}) => types.includes(GoogleMapMainAreaKey));

export const getSubAreaLayer = addressComponents =>
    addressComponents?.find(({types}) => types.some(type => GoogleMapSubAreaApiKeys.includes(type)));
